import {
  Flex
} from 'antd';
import React from 'react';
import { Typography } from 'tfc-components';

import { TCleanRequire } from '.';

import Icon from 'components/atoms/Icon';
import CleanData from 'components/organisms/CleanData';

interface Props {
  cleanRequire: TCleanRequire;
  setCleanRequire: (data: TCleanRequire) => void;
  typeSwitch: 'now' | 'after';
}

const CleanDataStep: React.FC<Props> = ({
  cleanRequire, setCleanRequire, typeSwitch
}) => {
  if (typeSwitch === 'now') {
    return (
      <div className="p-changePlan_cleanWrap">
        <CleanData setCleanRequire={setCleanRequire} cleanRequire={cleanRequire} />
      </div>
    );
  }

  return (
    <div className="fs-18x21 p-changePlan_cleanDataNoti">
      <Flex vertical gap={8} align="center" justify="center">
        <div className="p-changePlan_cleanDataNoti_iconWrap">
          <Icon iconName="icInfoBgWhite" size="30" />
        </div>

        <Typography.Text extendClasses="fs-24x32" fontweight="600">Notification</Typography.Text>

        <Typography.Text extendClasses="fs-18x21 p-changePlan_cleanDataNoti_center">
          Please delete unnecessary data or schedule files for deletion before
          {' '}
          <Typography.Text type="span" fontweight="600">3 days</Typography.Text>
          {' '}
          to avoid having your new plan locked.
          If no action is taken, the system will automatically
          restrict access to the new plan until your storage usage is
          adjusted to fit the new plan’s limit.
        </Typography.Text>
      </Flex>
    </div>
  );
};

export default CleanDataStep;
